import { ReactComponent as GolfIcon } from "icons/m2c-golf.svg";
import { ReactComponent as LaunchIcon } from "icons/m2c-launch.svg";
import { ReactComponent as AthelticsIcon } from "icons/athleticsLogo.svg";
import { ReactComponent as SimulationIcon } from "icons/simulationProject.svg";
import { ReactComponent as AnalyticsIcon } from "icons/analytics-project.svg";
import { ReactComponent as TonalLogo } from "icons/tonalLogo.svg";
import { PGicon } from "icons";

export interface MenuItem {
  key: React.Key;
  icon?: React.ReactNode;
  label: React.ReactNode;
  children?: MenuItem[];
}

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
  onClick?: () => void, // Accept onClick function as a parameter
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
  };
}

const CustomIconWrapper = ({ children }: any) => (
  <div
    style={{
      border: "0.1px solid rgb(0, 106, 179, 0.2)",
      verticalAlign: "middle",
      display: "flex",
      justifyContent: "center",
      alignItems: "center", // Add alignItems property for vertical centering
      height: "35px",
      width: "35px",
      marginRight: "inherit",
      borderRadius: "5px",
      backgroundColor: "white",
    }}
  >
    {children}
  </div>
);

export const items: MenuItem[] = [
  getItem(
    "Motion2Coach Golf",
    "sub1",
    <CustomIconWrapper>
      <GolfIcon />
    </CustomIconWrapper>,
    [
      getItem("Dashboard", "1"),
      getItem("Statistics", "3"),
      getItem("History", "2"),
      getItem("Studio Stats", "22"),
    ],
  ),
  getItem(
    "Motion2Coach Launch",
    "sub2",
    <CustomIconWrapper>
      <LaunchIcon />
    </CustomIconWrapper>,
    [
      getItem("Dashboard", "4"), // Make sure this key is unique
      getItem("Statistics", "5"),
      getItem("History", "6"),
    ],
  ),

  getItem(
    "Motion2Coach Athletics",
    "sub3",
    <CustomIconWrapper>
      <AthelticsIcon />
    </CustomIconWrapper>,
    [
      getItem("Dashboard", "7"), // Make sure this key is unique
      getItem("Statistics", "8"),
      getItem("History", "9"),
    ],
  ),
  getItem(
    "Motion2Coach Simulation",
    "sub4",
    <CustomIconWrapper>
      <SimulationIcon />
    </CustomIconWrapper>,
    [
      getItem("Dashboard", "13"), // Make sure this key is unique
      getItem("Benchmarks", "21"),
      getItem("History", "14"),
    ],
  ),

  getItem(
    "Motion2Coach Analytics",
    "sub5",
    <CustomIconWrapper>
      <AnalyticsIcon />
    </CustomIconWrapper>,
    [
      getItem("Dashboard", "15"),
      getItem("History", "16"),
      getItem("Statistics", "19"),
      getItem("Tickets", "20"),
    ],
  ),
  getItem(
    "Performance Golf",
    "sub6",
    <CustomIconWrapper>
      <PGicon height={30} width={30} />
    </CustomIconWrapper>,
    [
      getItem("History", "17"), // Make sure this key is unique
    ],
  ),

  // getItem(
  //   "Motion2Coach Golf Sandbox",
  //   "sub4",
  //   <CustomIconWrapper>
  //     <GolfIcon />
  //   </CustomIconWrapper>,
  //   [
  //     getItem("Dashboard", "10"), // Make sure this key is unique
  //     getItem("Statistics", "11"),
  //     getItem("History", "12"),
  //   ]
  // ),
];

export function getOpenKeys(key: any) {
  const sub1 = ["1", "2", "3", "22"];
  const sub2 = ["4", "5", "6"];
  const sub3 = ["7", "8", "9"];
  const sub4 = ["13", "21", "14"];
  const sub5 = ["15", "16", "19", "20"];
  const sub6 = ["17"];
  if (sub1.includes(key)) return ["sub1"];
  if (sub2.includes(key)) return ["sub2"];
  if (sub3.includes(key)) return ["sub3"];
  if (sub4.includes(key)) return ["sub4"];
  if (sub5.includes(key)) return ["sub5"];
  if (sub6.includes(key)) return ["sub6"];
}
